import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 残存償却適用区分のENUM */
enum ResdDprecApplyType {
  /** 行う */
  execute = '1',
  /** 行わない */
  doNotExecute = '2',
}

const nameConfig = {
  execute: new Map([[Locale.ja, '行う']]),
  doNotExecute: new Map([[Locale.ja, '行わない']]),
};

const toEnum = rawValueToEnum(ResdDprecApplyType, ResdDprecApplyType.doNotExecute);
const toDisplay = enumToName(ResdDprecApplyType, nameConfig);
const toDisplayWithPrefix = enumToName(ResdDprecApplyType, nameConfig, { prefix: true });

export const resdDprecApplyType = {
  enum: ResdDprecApplyType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ResdDprecApplyType };
